import { trackRumAction } from '@/shared/observability/rum';

export type FpQaRumContext = {
  financialAdvisorId?: string | null;
  engagementId?: string | null;
  clientUserId?: string | null;
  careStageId?: string | null;
  specialtyId?: string | null;
  providerId?: string | null;
};

type FpQaEvent =
  | 'fp_qa_tab_view'
  | 'fp_qa_started'
  | 'fp_qa_completed'
  | 'fp_qa_results_loaded'
  | 'fp_qa_search_other_expanded'
  | 'fp_qa_selection_swapped'
  | 'fp_qa_provider_referred'
  | 'fp_qa_share_link_copied'
  | 'fp_qa_share_dialog_opened'
  | 'fp_qa_pdf_downloaded'
  | 'fp_qa_engagement_reopened'
  | 'fp_qa_engagement_renamed'
  | 'fp_qa_concierge_handoff_initiated';

const dropNullish = (ctx: FpQaRumContext): Record<string, unknown> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(ctx)) {
    if (value !== null && value !== undefined && value !== '') {
      out[key] = value;
    }
  }
  return out;
};

export function trackFpQaEvent(event: FpQaEvent, context: FpQaRumContext = {}): void {
  trackRumAction(event, dropNullish(context));
}
